function pageHeader() {
  return {
    template: require('./umb.pageHeader.html')
  };
};
export default pageHeader;


// WEBPACK FOOTER //
// ./src/login/header/umb.pageHeader.js